<template>
  <div class="course-session main-section">{{outlet}}</div>
</template>
